<!-- =========================================================================================
	File Name: App.vue
	Description: Main vue file - APP
	----------------------------------------------------------------------------------------
	Item Name: Vue Monica Refine Design
	Author: Riyan Kurniawan
	-- MONICA --
========================================================================================== -->

<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import themeConfig from '@/../themeConfig.js'
// import Snowflakes from 'magic-snowflakes'
// import { socket } from "@/socket";

export default {
  watch: {
    '$store.state.theme'(val) {
      this.toggleClassInBody(val)
    },
  },
  created() {
    // try {
    //   // await this.$auth.renewTokens();
    //   var sf = new Snowflakes({
    //     color: '#9ee8ff',
    //   })
    // } catch (e) {
    //   // (e);
    // }
  },
  methods: {
    toggleClassInBody(className) {
      if (className == 'dark') {
        if (document.body.className.match('theme-semi-dark'))
          document.body.classList.remove('theme-semi-dark')
        document.body.classList.add('theme-dark')
      } else if (className == 'semi-dark') {
        if (document.body.className.match('theme-dark'))
          document.body.classList.remove('theme-dark')
        document.body.classList.add('theme-semi-dark')
      } else {
        if (document.body.className.match('theme-dark'))
          document.body.classList.remove('theme-dark')
        if (document.body.className.match('theme-semi-dark'))
          document.body.classList.remove('theme-semi-dark')
      }
    },
  },
  mounted() {
    this.toggleClassInBody(themeConfig.theme)
  },
}
</script>

<style lang="scss">
/* Global Responsive Utilities */

/* Ensure viewport is properly set */
html {
  -webkit-text-size-adjust: 100%;
  -ms-text-size-adjust: 100%;
  overflow-x: hidden;
  max-width: 100vw;
}

body {
  overflow-x: hidden;
  max-width: 100vw;
}

/* Responsive container utilities */
.container-fluid-responsive {
  width: 100%;
  padding-right: 1rem;
  padding-left: 1rem;
  margin-right: auto;
  margin-left: auto;
}

@media (max-width: 768px) {
  .container-fluid-responsive {
    padding-right: 0.75rem;
    padding-left: 0.75rem;
  }
}

@media (max-width: 480px) {
  .container-fluid-responsive {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }
}

/* Responsive text utilities */
.text-mobile-small {
  @media (max-width: 768px) {
    font-size: 0.9rem !important;
  }

  @media (max-width: 480px) {
    font-size: 0.85rem !important;
  }
}

/* Responsive spacing utilities */
@media (max-width: 768px) {
  .p-mobile-sm {
    padding: 0.75rem !important;
  }

  .m-mobile-sm {
    margin: 0.5rem !important;
  }

  .gap-mobile-sm {
    gap: 0.5rem !important;
  }
}

/* Prevent horizontal scroll */
#app {
  overflow-x: hidden;
  max-width: 100vw;
  position: relative;
}

/* Responsive images and media */
img {
  max-width: 100%;
  height: auto;
}

/* Responsive tables */
@media (max-width: 768px) {
  table {
    display: block;
    overflow-x: auto;
    white-space: nowrap;
    -webkit-overflow-scrolling: touch;
  }

  .table-responsive {
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}

/* Fix vx-card responsive */
@media (max-width: 768px) {
  .vx-card {
    margin-bottom: 1rem !important;
  }

  .vx-card__title {
    font-size: 1.1rem !important;
  }

  .vx-card__body {
    padding: 1rem !important;
  }
}

@media (max-width: 480px) {
  .vx-card__body {
    padding: 0.75rem !important;
  }
}

/* Responsive buttons */
@media (max-width: 768px) {
  .vs-button {
    font-size: 0.9rem !important;
    padding: 0.6rem 1rem !important;
  }

  .vs-button--size-small {
    font-size: 0.8rem !important;
    padding: 0.5rem 0.75rem !important;
  }
}

/* Responsive form inputs */
@media (max-width: 768px) {
  .vs-input,
  .vs-select,
  .v-select {
    font-size: 0.9rem !important;
  }

  .vs-input--input {
    padding: 0.6rem !important;
  }
}

/* Responsive modals and popups */
@media (max-width: 768px) {
  .vs-popup {
    max-width: 95% !important;
    margin: 1rem !important;
  }

  .vs-popup--content {
    padding: 1rem !important;
  }
}

/* Fix dropdown positioning on mobile */
@media (max-width: 768px) {
  .vs-dropdown--menu {
    max-width: 90vw !important;
    left: 50% !important;
    transform: translateX(-50%) !important;
  }
}

/* Responsive grid system */
@media (max-width: 768px) {
  .vx-row {
    margin-left: -0.5rem !important;
    margin-right: -0.5rem !important;
  }

  .vx-col {
    padding-left: 0.5rem !important;
    padding-right: 0.5rem !important;
  }

  /* Force full width on mobile for common column classes */
  .vx-col.w-1\/2,
  .vx-col.w-1\/3,
  .vx-col.w-1\/4,
  .vx-col.w-2\/3,
  .vx-col.w-3\/4 {
    width: 100% !important;
  }

  /* Allow md breakpoint columns */
  .vx-col.md\:w-1\/2 {
    width: 50% !important;
  }
}

@media (max-width: 480px) {
  /* Force everything full width on tiny screens */
  .vx-col.md\:w-1\/2,
  .vx-col.sm\:w-1\/2 {
    width: 100% !important;
  }
}

/* Responsive navbar items */
@media (max-width: 768px) {
  .vs-navbar--item {
    padding: 0.5rem !important;
  }
}

/* Responsive scrollbar */
@media (max-width: 768px) {
  ::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 3px;
  }
}

/* Hide elements on mobile */
@media (max-width: 768px) {
  .hide-mobile {
    display: none !important;
  }

  .show-mobile {
    display: block !important;
  }
}

@media (min-width: 769px) {
  .hide-desktop {
    display: none !important;
  }

  .show-mobile {
    display: none !important;
  }
}

/* Responsive flexbox utilities */
@media (max-width: 768px) {
  .flex-mobile-col {
    flex-direction: column !important;
  }

  .flex-mobile-wrap {
    flex-wrap: wrap !important;
  }
}

/* Responsive chart containers */
@media (max-width: 768px) {
  .apexcharts-canvas {
    max-width: 100% !important;
  }

  #data-list-list-view {
    overflow-x: hidden !important;
  }
}

/* Safe area insets for mobile devices with notches */
@media (max-width: 768px) {
  #app {
    padding-left: env(safe-area-inset-left);
    padding-right: env(safe-area-inset-right);
  }
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.animate-spin {
  animation: spin 1s linear infinite;
  
}
</style>
